/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelProcessResponse } from '../../models/paged-model-process-response';

export interface ListProcesses1$Params {
  configId: string;
  pageable: Pageable;
}

export function listProcesses1(http: HttpClient, rootUrl: string, params: ListProcesses1$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessResponse>> {
  const rb = new RequestBuilder(rootUrl, listProcesses1.PATH, 'get');
  if (params) {
    rb.path('configId', params.configId, {});
    rb.query('pageable', params.pageable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProcessResponse>;
    })
  );
}

listProcesses1.PATH = '/config/{configId}/processes';
